@for (item of currentValue; track item) {
  <app-card [showHeader]="false">
    <div class="row">

      <div class="col-12 col-md-4">
        <mat-form-field appearance="outline" class="field-control w-100">
          <mat-label>Hora inicial</mat-label>
          <input matInput type="time" (change)="setStartHour(item, $event)" (focus)="onFocusElement($event)"
                 [value]="item.starHour"/>
        </mat-form-field>
      </div>

      <div class="col-12 col-md-4">
        <mat-form-field appearance="outline" class="field-control w-100">
          <mat-label>Hora final</mat-label>
          <input matInput type="time" (change)="setEndHour(item, $event)" (focus)="onFocusElement($event)"
                 [value]="item.endHour"/>
        </mat-form-field>
      </div>

      <div class="col-12 col-md-4">
        <app-field-select label="Zona horaria" optionConfigKey="timezone" [value]="item.timezone" (valueChange)="setTimezone(item, $event)"/>
      </div>
    </div>

    <div>
      @for (day of days; track day; let index = $index) {
        <mat-slide-toggle
          [checked]="item.days.includes(index)"
          (toggleChange)="toggleDay(item, index)"
          color="success"
        >
          {{ day }}
        </mat-slide-toggle>
        &nbsp;&nbsp;
      }
      <a href="javascript:void(0)" (click)="removeHour(item)"> Borrar </a>
    </div>
  </app-card>
}

<div class="add-pane" (click)="addHour()">
  <label>
    <i class="fi fi-br-time-add"></i>
    <span>Agregar horario</span>
  </label>
</div>
